import script from "./QuestReveal.vue?vue&type=script&setup=true&lang=js"
export * from "./QuestReveal.vue?vue&type=script&setup=true&lang=js"

import "./QuestReveal.vue?vue&type=style&index=0&id=1bda570c&scoped=true&lang=css"
import "./QuestReveal.vue?vue&type=style&index=1&id=1bda570c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1bda570c"]])

export default __exports__